export default __webpack_public_path__ + "static/diagram-1fccb7b16b2734027aac3234849d8054.svg";